/**
 * SPEC-UnifiedQADetail Phase 2 — unified QA detail route.
 *
 * Lazy-loads `qa-detail-v4`, which dispatches by `useViewMode()`:
 *   - 'senior' → legacy `qa-detail-v3` (one-cycle delegation, see SPEC
 *     §"Retained as-is")
 *   - 'agent'  → unified agent layout composed from the extracted
 *     sub-components.
 *
 * To roll back: swap the lazy import target to `./qa-detail-v3`.
 */
import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";

const QaDetailV4 = lazy(() => import("./qa-detail-v4"));

export default function QaDetail() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-full">
          <Skeleton className="h-8 w-48" />
        </div>
      }
    >
      <QaDetailV4 />
    </Suspense>
  );
}
